export enum TicketStatus {
  new = "new",
  open = "open",
  pending = "pending",
  hold = "hold",
  solved = "solved",
  closed = "closed",
}
